import { BaseResponseDto } from "./BaseResponseDto";

export class ResponseDto<T> extends BaseResponseDto<T> {
  public code!: number;
}
